
//IMPORTS
import React, {useCallback, useEffect,useState} from "react";
import {FormProvider, useForm, useFormContext, useWatch} from "react-hook-form";
import Tooltip from "@mui/material/Tooltip";

//COMPONENTS
import { CalendarForm, CalendarFormRange } from "../../../components/ComponentesFormularios/CalendarForm";
import TransfertList from "../../../components/TransferList";
import Tabs from "../../../components/Tabs";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";

//SERVICES
import { modalCRUDService } from "../../../services/modalCRUDService";
import { productosService } from "../../../services/apiProductos";
import { alertQuestionService } from "../../../services/alertQuestionService";

//CONSTANTS
import {
  classResponsiveForm,
  classResponsiveFormDoubleWidth, 
  classResponsiveFormShort, 
  classResponsiveFormWidthHeader, 
  ERRORFIELDREQUIRED,
  optionsEstados, 
  optionsIVAProductos, 
  optionsYesNo,
} from "../../../data/ConstantForm";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import { GlobalConstants } from "../../../data/GlobalConstants";

//REDUX
import {useDispatch, useSelector} from "react-redux";

//UTILS
import {
  convertToString,
  dateToStringFormat,
  getFechaToCalendarRange,
  validArray, 
  validObjectKeys
} from "../../../util/functions";
import {isEmpty, isObject} from "../../../util/is";

//STYLES
import {Colors} from "../../../assets/colors/Colors";

const optionsRespIVAVirtuales  = [
    {id: "Adquiriente", text: "Adquiriente"},
    {id: "Contribuyente", text: "Contribuyente"}
]

const optionsRespAdquiriente  = [
    {id: "Adquiriente", text: "Adquiriente"}
]

const optionsRespContribuyente  = [
  {id: "Contribuyente", text: "Contribuyente"}
]

const AplicaControlVenta = ({isEditing}) => {

  const { setValue, control, formState: { errors } } = useFormContext();

  const controlVenta = useWatch({
    control,
    name: "controlVenta"
  })

  useEffect(() => {

    if(controlVenta === "N"){
        setValue("cantMaxVenta", "0");
        setValue("cantVendida", "0");
    }

  }, [controlVenta])

  return(
    <>
      <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="cantMaxVenta" label="Cant. Máx. Venta"
                  placeholder="Ej: 20"  type="number" required={controlVenta !== "N"} className={`${classResponsiveFormShort}`}
                  customError={errors.cantMaxVenta ? ERRORFIELDREQUIRED : null} readOnly={controlVenta === "N"}/>

      <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="cantVendida" label="Cant. Vendida"
                  placeholder="Ej: 20"  type="number" required={controlVenta !== "N"}  className={`${classResponsiveFormShort}`}
                  customError={errors.cantVendida ? ERRORFIELDREQUIRED : null} readOnly={controlVenta === "N"}/>
    </>
  )

}

const JerarquiaProducto = ({isEditing, stateSelects}) => {

  const { setValue, control, formState: { errors } } = useFormContext();
  const [ stateJerarquiaEscrita, setStateJerarquiaEscrita ] = useState(true);
  const [ errorJerarquia, setErrorJerarquia ] = useState(false);
  const [ dataJerarquia, setDataJerarquia ] = useState({
    categoria: '-',
    subCategoria: '-',
    linea: '-',
    subLinea: '-',
    marca: '-',
    subMarca: '-',
  });

  const values = useWatch({
    control,
    name: ["jerarquia", "categoria", "subCategoria", "linea", "subLinea", "marca", "subMarca", "jerarquiaEscrita"]
  })

  useEffect(() => {
    setStateJerarquiaEscrita(values[7] === "S");
  }, [values[7]])

  useEffect(() => {
    let jerarquia = values[0];

    if(jerarquia?.length >= 18){

      productosService.validarJerarquia( {jerarquia} ).then(
        response => {
          const { status, data } = response;

          if (!(status && data.validation)) {
            setErrorJerarquia(false);
            alertQuestionService.showAlert({
              title: 'Error de jerarquia',
              type: GlobalConstants.alertError,
              message: 'La jerarquia seleccionada no existe, debes seleccionar una jerarquia correcta para guardar de forma exitosa el producto',
              close: true,
              labelAceptar: "Aceptar",
              actionBtnAceptar: () => alertQuestionService.clear()
            })
          }
          else if(data.selects){
            const { categoria, nmCategoria, subCategoria, nmSubcategoria, linea, nmLinea, subLinea, nmSubLinea, marca, nmMarca, subMarca, nmSubmarca } = data.selects;

            setValue("categoria", `${isEmpty(categoria) ? "" : categoria}`);
            setValue("subCategoria", `${isEmpty(subCategoria) ? "" : subCategoria}`);
            setValue("linea", `${isEmpty(linea) ? "" : linea}`);
            setValue("subLinea", `${isEmpty(subLinea) ? "" : subLinea}`);
            setValue("marca", `${isEmpty(marca) ? "" : marca}`);
            setValue("subMarca", `${isEmpty(subMarca) ? "" : subMarca}`);
            
            setDataJerarquia({
              categoria: isEmpty(nmCategoria) ? "" : `${categoria}-${nmCategoria}`,
              subCategoria: isEmpty(nmSubcategoria) ? "" : `${subCategoria}-${nmSubcategoria}`,
              linea: isEmpty(nmLinea) ? "" : `${linea}-${nmLinea}`,
              subLinea: isEmpty(nmSubLinea) ? "" : `${subLinea}-${nmSubLinea}`,
              marca: isEmpty(nmMarca) ? "" : `${marca}-${nmMarca}`,
              subMarca: isEmpty(nmSubmarca) ? "" : `${subMarca}-${nmSubmarca}`,
            })
            setErrorJerarquia(true);

          }

        },
        error => {
          setErrorJerarquia(false);
          alertQuestionService.showAlert({
            title: 'Error de jerarquia',
            type: GlobalConstants.alertError,
            message: 'La jerarquia seleccionada no existe, debes seleccionar una jerarquia correcta para guardar de forma exitosa el producto',
            close: true,
            labelAceptar: "Aceptar",
            actionBtnAceptar: () => alertQuestionService.clear()
          })
        }
      );

    }

  }, [values[0]])

  const handleSelectChange = () => {
    let categoria = isObject(values[1]) ? values[1]?.id : values[1];
      let subCategoria = isObject(values[2]) ? values[2]?.id : values[2];
      let linea = isObject(values[3]) ? values[3]?.id : values[3];
      let subLinea = isObject(values[4]) ? values[4]?.id : values[4];
      let marca = isObject(values[5]) ? values[5]?.id : values[5];
      let subMarca = isObject(values[6]) ? values[6]?.id : values[6];

      let jerarquia = `${isEmpty(categoria) ? "" : categoria}${isEmpty(subCategoria) ? "" : subCategoria}${isEmpty(linea) ? "" : linea}${isEmpty(subLinea) ? "" : subLinea}${isEmpty(marca) ? "" : marca}${isEmpty(subMarca) ? "" : subMarca}`

      setValue("jerarquia", jerarquia);
  }

  return(
    <div className="row mx-0 px-0 mt-2 d-flex flex-column">
      <div >
        <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="tipoNegocio" label="Tipo Negocio"
                                      options={stateSelects?.objArrClasificacionProductos?.negocio}  required={false} className={`${classResponsiveForm}`}
                                      customError={errors.tipoNegocio ? ERRORFIELDREQUIRED : null}/>

        <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="familia" label="Familia"
                              options={stateSelects?.objArrClasificacionProductos?.familia}  required={false} className={`${classResponsiveForm}`}
                              customError={errors.familia ? ERRORFIELDREQUIRED : null}/>

        <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="jerarquiaEscrita" options={optionsYesNo}
                        defaultValue="S" label="Jerarquia Escrita" required={false} className={`${classResponsiveFormShort}`}
                        customError={errors.jerarquiaEscrita ? ERRORFIELDREQUIRED : null}/>

        <InputForm inputProps={{control}} disabled={!isEditing} readOnly={values[7] === "N"} identificador="jerarquia" label="Jerarquía"
                  placeholder="Ej: 010000102300223"  type="text" required={true} className={`${classResponsiveForm}`}
                  rules={{minLength: 18, maxLength: 18, validate: value => errorJerarquia === true || '*Jerarquía no válida'}}
                  customError={errors.jerarquia ? errors.jerarquia.message ? errors.jerarquia.message : '*Longitud min 18 y max 18' : null}
                  />
      </div>


      <div className="mb-3">
        <table className="d-table w-100 mx-2">
          <thead>
            <tr style={{ backgroundColor: '#ebebeb', color: '#404040', textAlign: 'center', }}>
              <td style={{borderRight: '5px solid white'}}>Categoria</td>
              <td style={{borderRight: '5px solid white'}}>Sub Categoria</td>
              <td style={{borderRight: '5px solid white'}}>Linea</td>
              <td style={{borderRight: '5px solid white'}}>Sub Linea</td>
              <td style={{borderRight: '5px solid white'}}>Marca</td>
              <td >Sub Marca</td>
            </tr>
          </thead>
          <tbody>
            <tr style={{fontWeight: 'bold', textAlign: 'center'}}>
              <td>{dataJerarquia.categoria}</td>
              <td>{dataJerarquia.subCategoria}</td>
              <td>{dataJerarquia.linea}</td>
              <td>{dataJerarquia.subLinea}</td>
              <td>{dataJerarquia.marca}</td>
              <td>{dataJerarquia.subMarca}</td>
            </tr>
          </tbody>
          
        </table>
      </div>

        <div className={`d-flex align-items-center justify-content-between ${stateJerarquiaEscrita ? 'saDisable' : ''}`}>

          <SelectFormVirtualize inputProps={{control}} disabled={!(isEditing && values[7] === "N")} identificador="categoria" label="Categoria"
                                options={stateSelects?.objArrClasificacionProductos?.categoria} className="w-25 mx-2"
                                customError={errors.categoria ? ERRORFIELDREQUIRED : null}/>

          <SelectFormVirtualize inputProps={{control}} disabled={!(isEditing && values[7] === "N")} identificador="subCategoria" label="Sub Categoria"
                                options={stateSelects?.objArrClasificacionProductos?.subCategoria} className="w-25 mx-2"
                                customError={errors.subCategoria ? ERRORFIELDREQUIRED : null}/>

          <SelectFormVirtualize inputProps={{control}} disabled={!(isEditing && values[7] === "N")} identificador="linea" label="Linea"
                                options={stateSelects?.objArrClasificacionProductos?.linea} className="w-25 mx-2"
                                customError={errors.linea ? ERRORFIELDREQUIRED : null}/>
          <SelectFormVirtualize inputProps={{control}} disabled={!(isEditing && values[7] === "N")} identificador="subLinea" label="Sub Linea"
                                options={stateSelects?.objArrClasificacionProductos?.subLinea} className="w-25 mx-2"
                                customError={errors.subLinea ? ERRORFIELDREQUIRED : null}/>

          <SelectFormVirtualize inputProps={{control}} disabled={!(isEditing && values[7] === "N")} identificador="marca" label="Marca"
                                options={stateSelects?.objArrClasificacionProductos?.marca} className="w-25 mx-2"
                                customError={errors.marca ? ERRORFIELDREQUIRED : null}/>

          <SelectFormVirtualize inputProps={{control}} disabled={!(isEditing && values[7] === "N")} identificador="subMarca" label="Sub Marca"
                                options={stateSelects?.objArrClasificacionProductos?.subMarca} className="w-25 mx-2"
                                customError={errors.subMarca ? ERRORFIELDREQUIRED : null}/>

          <div className="mx-2">
            {
              (isEditing && values[7] === "N") ? 
                <Tooltip title="Actualizar Jerarquía" aria-label="actualizar-jerarquia">
                    <a className="icon-container-actions d-flex"
                    onClick={handleSelectChange}>
                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-sync fa-2x"/>
                    </a>
                </Tooltip>
              : <Tooltip title="Actualizar Jerarquía" aria-label="actualizar-jerarquia">
                    <a className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.DARK_GRAY}}/>
                    <i style={{color: Colors.DARK_GRAY}} className="fas fa-sync fa-2x"/>
                    </a>
                </Tooltip>
            }
          </div>

        </div>

    </div>
  )

}

const Cucharas = ({isEditing}) => {

  const { control, formState: { errors } } = useFormContext();

  const aplicaCucharas = useWatch({
    control,
    name: "nbCucharas"
  })

  return(
    <>
      <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={(!isEditing || aplicaCucharas === "N")} identificador="nbCantidadCucharas" label="Número Cucharas"
                  placeholder="Ej: 1"  required={aplicaCucharas === "S"} type="number"  className={`${classResponsiveFormShort}`}
                  customError={errors.nbCantidadCucharas ? ERRORFIELDREQUIRED : null}/>

      <InputForm  inputProps={{control}} disabled={(!isEditing  || aplicaCucharas === "N")} identificador="nbProductoCuchara" label="Código Cucharas"
                  placeholder="Ej: 12"  required={aplicaCucharas === "S"} type="text"  className={`${classResponsiveForm}`}
                  customError={errors.nbProductoCuchara ? ERRORFIELDREQUIRED : null}/>
    </>
  )

}

const DatosBasicos = React.memo(({isEditing, stateSelects}) => {

    const { control, formState: { errors } } = useFormContext();

    return(
        <div className="container mx-0 px-0 w-100 mw-100">
            <div className="mx-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Identificación y clasificación</span>
            </div>
            <div className="row mx-0 px-0 mt-2">

              <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="proveedor" label="Proveedor"
                    options={stateSelects?.arrProveedores} required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.proveedor ? ERRORFIELDREQUIRED : null} />

              <InputForm inputProps={{control}} disabled={!isEditing} identificador="codProProveedor" label="Cod. Prod. Proveedor"
                          placeholder="Ej: 10002"  type="text" required={false} className={`${classResponsiveForm}`}
                          customError={errors.codProProveedor ? ERRORFIELDREQUIRED : null}/>

              <InputForm inputProps={{control}} disabled={!isEditing} identificador="codigoEan" label="Cod. EAN"
                          placeholder="Ej: 34323142343"  type="text" required={false} className={`${classResponsiveForm}`}
                          customError={errors.codigoEan ? ERRORFIELDREQUIRED : null}/>

              <InputForm inputProps={{control}} disabled={!isEditing} identificador="codigoBarrasAuxiliar" label="Cod. Barras Auxiliar"
                          placeholder="Ej: 34323142343"  type="text" required={false} className={`${classResponsiveForm}`}
                          customError={errors.codigoBarrasAuxiliar ? ERRORFIELDREQUIRED : null}/>

              <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="jsSubPortafolios" label="Portafolio de materiales"
                              options={stateSelects?.arrSubPortafolios}  required={true} className={`w-auto px-2 mw150`}
                              customError={errors.tipoNegocio ? ERRORFIELDREQUIRED : null} isMulti/>


            </div>
            <div className="mx-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Jerarquía de productos</span>
            </div>

            <JerarquiaProducto isEditing={isEditing} stateSelects={stateSelects} />

            <div className="mx-2 text-center text-muted content-divider divider-form">
              <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Embalaje y almacenamiento</span>
            </div>
            <div className="row mx-0 px-0 mt-2">

              <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="tipoEmbalaje" label="Tipo Embalaje"
                                    options={stateSelects?.arrTiposEmbalajes}  required={true} showId={false} className={`${classResponsiveForm}`}
                                    customError={errors.tipoEmbalaje ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="unidadEmbalaje" label="Unidades por embalaje"
                          placeholder="Ej: 1"  required={true} type="number"  className={`${classResponsiveFormShort}`}
                          customError={errors.unidadEmbalaje ? ERRORFIELDREQUIRED : null}/>

              <SelectForm inputProps={{control}} disabled={!isEditing} identificador="tipoAlmacenamiento" label="Tipo de almacenamiento"
                          options={stateSelects?.arrTiposAlmacenaje}  required={true} showId={false} className={`${classResponsiveForm}`}
                          customError={errors.tipoAlmacenamiento ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="largo" label="Largo"
                          placeholder="Ej: 2" required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.largo ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="ancho" label="Ancho"
                          placeholder="Ej: 12" required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.ancho ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="alto" label="Alto"
                          placeholder="Ej: 21" required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.alto ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="peso" label="Peso"
                          placeholder="Ej: 10" required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.peso ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="pesoNeto" label="Peso Neto"
                          placeholder="Ej: 10" required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.pesoNeto ? ERRORFIELDREQUIRED : null}/>

              <SelectFormVirtualize inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="unidadMedida" label="Unidad de medida"
                          options={stateSelects?.arrUnidadesMedida}  required={true} showId={true} className={`${classResponsiveForm}`}
                          customError={errors.unidadMedida ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="unidadesCaja" label="Unidades Caja"
                          placeholder="Ej: 1" required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.unidadesCaja ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="unidadesDisplay" label="Unidades Display"
                          placeholder="Ej: 3" required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.unidadesDisplay ? ERRORFIELDREQUIRED : null}/>

              <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="particion" label="Partición"
                          placeholder="Ej: 11" required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.particion ? ERRORFIELDREQUIRED : null}/>

            </div>



            <div className="mx-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Monetización de mercancia</span>
            </div>
            <div className="row mx-0 px-0 mt-2">


                    <SelectForm inputProps={{control}} disabled={!isEditing} identificador="moneda" label="Moneda"
                                options={stateSelects?.arrMonedas}  required={true} className={`${classResponsiveForm}`}
                                customError={errors.moneda ? ERRORFIELDREQUIRED : null}/>

                    <SelectForm  inputProps={{control}} disabled={!isEditing} identificador="iva" label="Iva"
                          options={optionsIVAProductos} required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.iva ? ERRORFIELDREQUIRED : null} showId={false}/>

                    <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="precioVenta" label="Precio Venta"
                          placeholder="Ej: 3000"  required={true} type="number" className={`${classResponsiveForm}`}
                          customError={errors.precioVenta ? ERRORFIELDREQUIRED : null}/>

                    <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="precioCompra" label="Precio Compra"
                          placeholder="Ej: 2000"  required={true} type="number"  className={`${classResponsiveForm}`}
                          customError={errors.precioCompra ? ERRORFIELDREQUIRED : null}/>

                <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="vlProductoSugerido" label="Valor Sugerido"
                            placeholder="Ej: 2000"  required={false} type="number"  className={`${classResponsiveForm}`}
                            customError={errors.precioCompra ? ERRORFIELDREQUIRED : null}/>


              <InputForm  inputProps={{control}} disabled={!isEditing} identificador="observacion" label="Observaciones"
                                placeholder="Ej: Observación"  required={false} type="text" className={`${classResponsiveForm}`}
                                customError={errors.observacion ? ERRORFIELDREQUIRED : null}/>


            </div>

            <div className="mx-2 text-center text-muted content-divider divider-form">
              <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Para Facturación</span>
            </div>
            <div className="row mx-0 px-0 mt-2">

              <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="controlVenta" options={optionsYesNo}
                               defaultValue="S" label="Aplica Control Ventas" required={true} className={`${classResponsiveFormShort}`}
                               customError={errors.controlVenta ? ERRORFIELDREQUIRED : null}/>

              <AplicaControlVenta isEditing={isEditing}/>

              <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="nbCucharas" options={optionsYesNo}
                               defaultValue="N" label="Aplica Cucharas" required={false} className={`${classResponsiveFormShort}`}
                               customError={errors.nbCucharas ? ERRORFIELDREQUIRED : null}/>

              <Cucharas isEditing={isEditing}/>

              <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="sumaHijos100" options={optionsYesNo}
                               defaultValue="N" label="Suma Hijos 100%" required={false} className={`${classResponsiveFormShort}`}
                               customError={errors.sumaHijos100 ? ERRORFIELDREQUIRED : null}/>

            </div>


            <div className="mx-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Aplicaciones móviles</span>
            </div>
            <div className="row mx-0 px-0 mt-2">

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="aceptaCambios" options={optionsYesNo}
                                 defaultValue="N" label="Acepta Cambios" required={true} className={`${classResponsiveFormShort}`}
                                 customError={errors.aceptaCambios ? ERRORFIELDREQUIRED : null}/>

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="prodImpulsar" options={optionsYesNo}
                                 defaultValue="N" label="Prod. Impulsar" required={true} className={`${classResponsiveFormShort}`}
                                 customError={errors.prodImpulsar ? ERRORFIELDREQUIRED : null}/>

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="obligaImpulsar" options={optionsYesNo}
                                 defaultValue="N" label="Obliga Impulsar" required={true} className={`${classResponsiveFormShort}`}
                                 customError={errors.obligaImpulsar ? ERRORFIELDREQUIRED : null}/>

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="venderApp" options={optionsYesNo}
                                 defaultValue="N" label="Ver en la app" required={true} className={`${classResponsiveFormShort}`}
                                 customError={errors.venderApp ? ERRORFIELDREQUIRED : null}/>

                <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="valorMinimo" label="Valor Mínimo"
                          placeholder="Ej: 2500"  required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.valorMinimo ? ERRORFIELDREQUIRED : null}/>

                <InputForm  inputProps={{control, min: 0, step: "0.01", maxLength: 10}} disabled={!isEditing} identificador="valorMaximo" label="Valor Máximo"
                          placeholder="Ej: 5000"  required={true} type="number" className={`${classResponsiveFormShort}`}
                          customError={errors.valorMaximo ? ERRORFIELDREQUIRED : null}/>

                <InputForm  inputProps={{control}} disabled={!isEditing} identificador="colorSegmentacion" label="Color Microsegmentación"
                                 placeholder="Ej: Hexadecimal" required={false}  type="text" className={`${classResponsiveFormShort}`}
                                 customError={errors.colorSegmentacion ? ERRORFIELDREQUIRED : null}/>


            </div>

        </div>
    )

})

const ProductosSustitutos = React.memo(({isEditing, stateSelects, isAddMode}) => {

    const { setValue, control} = useFormContext();

    const jsProducto = useWatch({
      name: "jsProducto",
      control
    })

    const proveedor = useWatch({
      name: "proveedor",
      control
    })

    const onChange = ({dataSelectedTemp}) => {

        let arrProductosSustitutos = [];
        let arrEnviar = {};
        let error = false;
        try{

            let arr = Object.assign({}, jsProducto);
            const { jsProdVirtual } = arr;

            for(let item of dataSelectedTemp){
                arrProductosSustitutos.push({
                    nbProducto: item.id,
                    nmProducto: item.text
                })
            }

            arrEnviar["jsProdSustitutos"] = arrProductosSustitutos.slice();
            arrEnviar["jsProdVirtual"] = jsProdVirtual.slice();

        }
        catch (e) { error = true; }

        if(!error){
            setValue("jsProducto", arrEnviar)
        }

    }

    const formatJsonProdSustitutos = useCallback((arrProdSustitutos) => {

          if(arrProdSustitutos?.length > 0){

              let arrReturn = [];

              for(let item of arrProdSustitutos){

                  arrReturn.push({
                    id: item.nbProducto,
                    text: item.nmProducto
                  })

              }

              return arrReturn;

          }

          return [];

    }, []);

    return (
        <div className="mt-3">
            <TransfertList dataShow={stateSelects?.arrTodosProductos?.filter(x => convertToString(x.proveedor) === convertToString(isObject(proveedor) ? proveedor.id : proveedor)) || []}
                           dataSelect={formatJsonProdSustitutos(jsProducto?.jsProdSustitutos) || []}
                           disabled={!isEditing}
                           onChange={({dataSelectedTemp}) => onChange({dataSelectedTemp})}
                           labelMuestra="Muestra de productos" labelSelected="Productos Sustitutos"/>
        </div>
    )

})

const TableProductosVirtuales = ({data = []}) =>{

  const { setValue, formState: { errors }} = useFormContext();

  const { jsProdVirtual } = data;

  const handleEliminarVirtual = (idProducto, obsequio) => {

      let arr = Object.assign({}, data);
      const { jsProdSustitutos, jsProdVirtual } = arr;

      let jsProductosSustitutosCopy = validArray(jsProdSustitutos).slice();
      let jsProdVirtualCopy = validArray(jsProdVirtual).slice();

      let jsProdVirtualNew = jsProdVirtualCopy.filter(x =>
        !(convertToString(x.nbProducto) === convertToString(idProducto) &&
        convertToString(x.tpObsequio) === convertToString(obsequio))
      )

      setValue("jsProducto", {
        jsProdVirtual: jsProdVirtualNew.slice(),
        jsProdSustitutos: jsProductosSustitutosCopy.slice()
      });

    }

    return(
        <table className="genericTableStyle">
            <thead className="sticky-top" style={{zIndex: 0}}>
            <tr className="tableHeaderGenericStyle">
                <th className="text-center">Tipo Linea</th>
                <th className="text-center">Obsequio</th>
                <th className="text-center">Aplic. Desc.</th>
                <th className="text-center">Enviar DIAN</th>
                <th className="text-center">Resp. IVA</th>
                <th className="text-center">Cod. Producto</th>
                <th className="text-center">Producto</th>
                <th className="text-center">Cantidad</th>
                <th className="text-center">% Descuento</th>
                <th className="text-center">% Participación</th>
                <th className="text-center">Acciones</th>
            </tr>
            </thead>
            <tbody>
            {
              jsProdVirtual.length === 0 ?
                    <tr className="text-center" style={{ height: 300 }}>
                        <td className="text-center font-weight-bold" style={{backgroundColor: 'white'}} colSpan={11}>Sin registros</td>
                    </tr>
                    :
                    <>
                        {
                          jsProdVirtual.map((item, index) => (
                                <tr key={`key${index}`}>
                                    <td className="text-center">{item.tpLinea}</td>
                                    <td className="text-center">{item.tpObsequio}</td>
                                    <td className="text-center">{item.boAplicaDescuento}</td>
                                    <td className="text-center">{item.boEnviarDIAN}</td>
                                    <td className="text-center">{item.txResponsableIVA}</td>
                                    <td className="text-center">{item.nbProducto}</td>
                                    <td className="text-center">{item.nmProducto}</td>
                                    <td className="font-weight-bold text-center" style={{color: Colors.RED_SWITCH_INACTIVE}}>{item.vlrCantidad}</td>
                                    <td className="text-center">{item.prcDescuento}</td>
                                    <td className="text-center">{item.prcParticipacion}</td>
                                    <td className="text-center cursor-pointer" onClick={() => handleEliminarVirtual(item.nbProducto, item.tpObsequio)}>
                                      <i style={{color: Colors.RED_SWITCH_INACTIVE, marginLeft: 5}} className="fas fa-trash fa-lg"/>
                                    </td>
                                </tr>
                            ))
                        }
                    </>
            }
            </tbody>
        </table>
    )

}

const FormProductosVirtuales = ({control, setValue, errorsVirtuales, isEditing, stateSelects, isAddMode, controlGeneral}) => {

  const generalServicesState = useSelector( state => state.generalServices )

  const [ statesLockAmarreTradicional, setStatesLockAmarreTradicional ] = useState({
    stateLockAmarreTradicional: false,
    validarAplicaSumaHijos: "N"
  });

  const { stateLockAmarreTradicional, validarAplicaSumaHijos } = statesLockAmarreTradicional;

  const tipoProducto = useWatch({
    name: "tipoProducto",
    control: controlGeneral
  })

  const tpLineaVirtual = useWatch({
    name: "tpLineaVirtual",
    control
  })

  const aplicaDescuentoVirtual = useWatch({
    name: "aplicaDescuentoVirtual",
    control
  })

  useEffect(() => {

    if(tpLineaVirtual?.id === 'P'){
      setValue("enviarDIANVirtual", "S");
      setValue("obsequioVirtual", "N");
    }
    else if(tpLineaVirtual?.text?.includes('OBSEQUIO')){
      setValue("obsequioVirtual", "S");
    }
    else{
      setValue("obsequioVirtual", "N");
    }

  }, [tpLineaVirtual])

  useEffect(() => {

    let tipoProductoTemp = isObject(tipoProducto) ? tipoProducto?.id : tipoProducto;
    if(tipoProductoTemp?.includes('VIRTUAL AMARRE') || tipoProductoTemp?.includes('VIRTUAL TRADICIONAL')){
      setValue("enviarDIANVirtual", "N");
      setValue("obsequioVirtual", "N");
      setValue("aplicaDescuentoVirtual", "N");
    }

  }, [tipoProducto])

  useEffect(() => {

    if(convertToString(aplicaDescuentoVirtual) === "N"){
      setValue("prcDescuento", "0");
    }

    }
  , [aplicaDescuentoVirtual])

  useEffect(() => {

    if(convertToString(validarAplicaSumaHijos) === "N"){
        setValue("prcParticipacion", "100");
    }
    else{
        setValue("prcParticipacion", "0");
    }


  }, [tipoProducto, validarAplicaSumaHijos])

  useEffect(() => {

    let tipoProductoTemp = isObject(tipoProducto) ? tipoProducto?.id : tipoProducto;
    let arrTiposProductos = validArray(generalServicesState?.arrTiposProductos).slice();
    let tipoProductoObj = arrTiposProductos.find(x => convertToString(x.id) === convertToString(tipoProductoTemp));

    setStatesLockAmarreTradicional({
      stateLockAmarreTradicional: (tipoProductoTemp?.includes('VIRTUAL AMARRE') || tipoProductoTemp?.includes('VIRTUAL TRADICIONAL')),
      validarAplicaSumaHijos: tipoProductoObj?.aplicaSumaHijos
    });

  }, [tipoProducto])

  return(
    <div className="row justify-content-between mw-100 m-0 p-2" style={{border: `1px solid ${Colors.COLOR_BLUE_THEME}`, borderRadius: 7}}>

      <NestedSelectVirtualizeForm customControl={control} disabled={!isEditing} keyIdentificador="codProductoVirtual" keyFatherValue="proveedor"
                                  label="Cod. Producto" options={stateSelects?.arrTodosProductos}
                                  required={true} className={`${classResponsiveFormWidthHeader}`} showId={true}
                                  customError={errorsVirtuales.codProductoVirtual ? ERRORFIELDREQUIRED : null}
      />

      <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="tpLineaVirtual" label="Tipo Linea"
                  required={true} options={stateSelects?.arrTiposLinea?.filter(x => convertToString(x.tipoProducto) === convertToString(
                    isObject(tipoProducto) ? tipoProducto?.id : tipoProducto
                   ) )}  className={`${classResponsiveForm}`} customError={errorsVirtuales.tpLineaVirtual ? ERRORFIELDREQUIRED : null}   />

      <RadioButtonForm inputProps={{control}} disabled={!isEditing || (tpLineaVirtual?.id === 'P' || stateLockAmarreTradicional)} identificador="enviarDIANVirtual"
                       options={optionsYesNo} required={true} defaultValue="N" label="Enviar DIAN" className={`px-3`} customError={errorsVirtuales.enviarDIANVirtual ? ERRORFIELDREQUIRED : null}   />

      <SelectForm inputProps={{control}} disabled={!isEditing} identificador="responsableIVAVirtual" label="Responsable IVA"
                  required={true} options={ tpLineaVirtual?.id === 'P' ? optionsRespAdquiriente :
                  stateLockAmarreTradicional ? optionsRespContribuyente : optionsRespIVAVirtuales}  className={`${classResponsiveForm}`}
                  customError={errorsVirtuales.responsableIVAVirtual ? ERRORFIELDREQUIRED : null}   />

      <RadioButtonForm inputProps={{control}} disabled={!isEditing || stateLockAmarreTradicional} identificador="aplicaDescuentoVirtual" options={optionsYesNo} required={true}
                       defaultValue="N" label="Apl. Desc." className={`px-3`}
                       customError={errorsVirtuales.aplicaDescuentoVirtual ? ERRORFIELDREQUIRED : null}   />

      <InputForm  inputProps={{control}} readOnly={convertToString(aplicaDescuentoVirtual) === "N"} disabled={!isEditing || stateLockAmarreTradicional} identificador="prcDescuento" type="number" label="% Descuento"
                  required={true}  placeholder="Ej: 10" className={`px-2 col-1`}
                  customError={errorsVirtuales.prcDescuento ? ERRORFIELDREQUIRED : null}   />

      <InputForm  inputProps={{control}} disabled={!isEditing} identificador="cantidadVirtual" type="number" label="Cantidad"
                  required={true}  placeholder="Ej: 10" className={`px-2 col-1`}
                  customError={errorsVirtuales.cantidadVirtual ? ERRORFIELDREQUIRED : null}   />

      <InputForm  inputProps={{control}} readOnly={convertToString(validarAplicaSumaHijos) === "N"} disabled={!isEditing} identificador="prcParticipacion" type="number" label="% Participación"
                  required={true}  placeholder="Ej: 10" className={`px-2 col-1`}
                  customError={errorsVirtuales.prcParticipacion ? ERRORFIELDREQUIRED : null}   />

      <RadioButtonForm inputProps={{control}} disabled={!isEditing || (tpLineaVirtual?.id === 'P' || stateLockAmarreTradicional)}
                       identificador="obsequioVirtual" options={optionsYesNo} required={true}
                       defaultValue="N" label="Obsequio" className={`px-3`}
                       customError={errorsVirtuales.obsequioVirtual ? ERRORFIELDREQUIRED : null}
      />

    </div>
  )

}

const ProductosVirtuales = ({isEditing, stateSelects, isAddMode}) => {

  const dispatch = useDispatch();

    const { setValue, formState: { errors }, control } = useFormContext();

    const tipoProducto = useWatch({
      name: "tipoProducto",
      control
    })

    const jsProducto = useWatch({
      name: "jsProducto",
      control
    })

    const { register: registerVirtual, setValue: setValueVirtual, handleSubmit: handleSubmitVirtual,
      reset: resetVirtual, control: controlVirtual, formState: {errors: errorsVirtuales} } = useForm({defaultValues: {
        aplicaDescuentoVirtual : "N"
      }});

    const onSuccessAddToList = data => {

        let arrProductosVirtuales = [];
        let arrEnviar = {};
        let error = false;

        try{

            let arr = Object.assign({}, jsProducto);
            const { jsProdSustitutos, jsProdVirtual } = arr;

            arrProductosVirtuales = jsProdVirtual.slice();

            const existeRegistro = arrProductosVirtuales.findIndex(x => convertToString(x.nbProducto) === convertToString(data?.codProductoVirtual?.id)
            && convertToString(x.tpObsequio) === convertToString(data.obsequioVirtual)) !== -1;

            if(existeRegistro){
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: `Ya existe el registro con identificador #${data?.codProductoVirtual?.id} y tipo obsequio con valor ${data.obsequioVirtual}` } });
                return;
            }

            arrProductosVirtuales.push({
                tpLinea: data?.tpLineaVirtual?.id,
                tpObsequio: data.obsequioVirtual,
                boAplicaDescuento: data.aplicaDescuentoVirtual,
                boEnviarDIAN: data.enviarDIANVirtual,
                txResponsableIVA: data.responsableIVAVirtual,
                nbProducto: data?.codProductoVirtual?.id,
                nmProducto: data?.codProductoVirtual?.text,
                vlrCantidad: data.cantidadVirtual,
                prcDescuento: data.prcDescuento,
                prcParticipacion: data.prcParticipacion,
                vlrCompra: 0,
                vlrVenta: 0
            })


            arrEnviar["jsProdSustitutos"] = jsProdSustitutos.slice();
            arrEnviar["jsProdVirtual"] = arrProductosVirtuales.slice();


        }
        catch (e) { error = true; }

        if(!error){
            setValue("jsProducto", arrEnviar);
            resetVirtual({
              codProductoVirtual: null,
              tpLineaVirtual: null,
              enviarDIANVirtual: "N",
              responsableIVAVirtual: "N",
              aplicaDescuentoVirtual: "N",
              cantidadVirtual: "0",
              obsequioVirtual: "0",
              prcParticipacion: convertToString(tipoProducto?.aplicaSumaHijos) === "N" ? "100" : "0",
              prcDescuento: "0"
            });
        }
    }

    const onErrorAddToList = errors => {
        console.log(errors);
    }

    useEffect(() => {
        registerVirtual("codProductoVirtual", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
    }, [])


    return(
        <div className="mt-3">

        <FormProductosVirtuales isEditing={isEditing} errorsVirtuales={errorsVirtuales} control={controlVirtual} controlGeneral={control} stateSelects={stateSelects} setValue={setValueVirtual} isAddMode={isAddMode} />

        <div className="row mw-100 m-0 justify-content-center">
            <div onClick={handleSubmitVirtual(onSuccessAddToList, onErrorAddToList)}
                 className="container-btn-agregar-remove position-relative d-flex align-items-center justify-content-center p-2 my-4
                 col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-2">
                <div className="btnAgregarTL position-absolute w-100 h-100"/>
                <a className="colorBtnAgregarTl">
                    <span>Agregar</span>
                    <i style={{marginLeft: 5}} className="fas fa-angle-double-down"/>
                </a>
            </div>
        </div>


        <div className="w-100" style={{ border: `1px solid ${Colors.COLOR_BLUE_THEME}`, borderRadius: 2, minHeight: 200, maxHeight: 500, overflowY: "auto" }}>
            <TableProductosVirtuales data={jsProducto} />
        </div>

        </div>
    )

}

const RenderTabs = ({isEditing, properties, stateSelects, isAddMode}) => {

  const { control, setValue, getValues } = useFormContext();

  const tipoProducto = useWatch({
      name: "tipoProducto",
      control
  })

  const jsProducto = useWatch({
    name: "jsProducto",
    control
  })

  useEffect(() => {
    let tipoProductoTemp = isObject(tipoProducto) ? tipoProducto?.id : tipoProducto;

    if(!(tipoProductoTemp?.includes('VIRTUAL'))) {

      let arr = Object.assign({}, jsProducto);
      const {jsProdSustitutos, jsProdVirtual} = arr;

      let jsProductosSustitutosCopy = validArray(jsProdSustitutos).slice();

      setValue("jsProducto", {
        jsProdVirtual: [],
        jsProdSustitutos: jsProductosSustitutosCopy.slice()
      });

    }
  }, [tipoProducto])

  return(
    <Tabs tabs={[
      {show: true, text: "Datos Básicos", value: "datosBasicos", icon: "fas fa-briefcase",
        component: <DatosBasicos isEditing={isEditing} properties={properties} stateSelects={stateSelects} isAddMode={isAddMode}/>},
      {show: true, text: "Productos Sustitutos", value: "prodSustitutos", icon: "fas fa-gift",
        component: <ProductosSustitutos isEditing={isEditing} stateSelects={stateSelects} isAddMode={isAddMode} />},
      {show: (isObject(tipoProducto) ? tipoProducto?.id : tipoProducto)?.includes('VIRTUAL'), text: "Productos Virtuales", value: "prodVirtuales", icon: "fas fa-suitcase",
        component: <ProductosVirtuales isEditing={isEditing} stateSelects={stateSelects} isAddMode={isAddMode} />}
    ]} defaultValue="datosBasicos" />
  )

}

const formatValueJsSubPortafolios = (jsSubPortafolios) => {

    let jsSubPortafoliosOld = [];
    try{
      jsSubPortafoliosOld = JSON.parse(jsSubPortafolios);
    }
    catch (e) { jsSubPortafoliosOld = []; }

    let jsSubPortafoliosNew = jsSubPortafoliosOld.map((item) => ({
      id: item.idRecurso,
      text: item.nmRecurso
    }));

    return jsSubPortafoliosNew;

}

const FormProductosCRUD = ({isEditing, properties, isAddMode}) => {

    const { data, params, tableRef, executeFn } = properties;
    const dispatch = useDispatch();
    const authState = useSelector( state => state.auth )
    const {idUsuario} = authState;
    const generalServicesState = useSelector( state => state.generalServices )
    const methods = useForm({defaultValues: {...data,
        nbCucharas: !isEmpty(data?.nbCantidadCucharas) && Number(data?.nbCantidadCucharas) > 0 ? "S" : "N",
        dtVigencia: getFechaToCalendarRange(data?.dtVigenciaIni ? data?.dtVigenciaIni : dateToStringFormat(new Date()), data?.dtVigenciaFin ? data?.dtVigenciaFin : '2200-12-31'),
        jsSubPortafolios: formatValueJsSubPortafolios(data?.jsSubPortafolios),
        jsProducto: {
              jsProdSustitutos: !isEmpty(data?.jsProducto?.jsProdSustitutos) ? data?.jsProducto?.jsProdSustitutos : [],
              jsProdVirtual: !isEmpty(data?.jsProducto?.jsProdVirtual) ? data?.jsProducto?.jsProdVirtual : [] 
            },
        jerarquiaEscrita: 'S'
        }});
    const { register, handleSubmit, formState: { errors }, control, getValues } = methods;


    const onSuccessSubmit = data => {

      let tipoProducto = getValues("tipoProducto");
      let jsProducto = getValues("jsProducto");
      let errors = 0;

      let arr = Object.assign({}, jsProducto);
      const { jsProdSustitutos, jsProdVirtual } = arr;

      if(validArray(jsProdVirtual).length > 0){
        let arrTiposProductos = validArray(generalServicesState?.arrTiposProductos).slice();
        let aplicaSumaHijos = arrTiposProductos.find(x => convertToString(x.id) === convertToString(
          isObject(tipoProducto) ? tipoProducto.id : tipoProducto
        ))
        let aplicaSuma = "";
        if(aplicaSumaHijos){
          aplicaSuma = convertToString(aplicaSumaHijos?.aplicaSumaHijos);
        }

        if(data?.sumaHijos100 === "S" && aplicaSuma === "S"){

          let jsProductosSustitutosCopy = validArray(jsProdSustitutos).slice();
          let jsProdVirtualCopy = validArray(jsProdVirtual).slice();
          let sumaPorcentajes = 0;
          for(let item of jsProdVirtual){

            try{
              sumaPorcentajes += Number(item.prcParticipacion);
            }
            catch (e) {
              errors++;
            }

          }

          if(sumaPorcentajes < 100 || sumaPorcentajes > 100){
            errors++;
          }

        }
        else if(data?.sumaHijos100 === "N" && aplicaSuma === "S"){

          let sumaPorcentajes = 0;
          for(let item of jsProdVirtual){

            try{
              sumaPorcentajes += Number(item.prcParticipacion);
            }
            catch (e) {
              errors++;
            }

          }

          if(sumaPorcentajes < 100 || sumaPorcentajes > 100){
            errors++;
          }

        }
      }

      if(errors > 0){
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Revisa tus productos virtuales, la suma de los porcentajes de participación no debe ser mayor al 100%" } });
        return;
      }

      data.dtVigenciaIni = dateToStringFormat(data.dtVigencia[0]);
      data.dtVigenciaFin = dateToStringFormat(data.dtVigencia[1]);
      data.ac = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';
      data.idUsrAuditoria = idUsuario;

      let jsSubPortafolios = validArray(data.jsSubPortafolios).slice();
      let jsSubPortafoliosEnviar = [];
      let objSubPortafoliosToViewPortafolios = {};

      for(let item of jsSubPortafolios){

        jsSubPortafoliosEnviar.push({
          idRecurso: item.id,
          nmRecurso: item.text
        })

        objSubPortafoliosToViewPortafolios[item.id] = {
          id: item.id,
          text: item.text
        }

      }

      let objPortafolios = {
        tpRecurso: "SUBPORTAFOLIO",
        arrRecursos: jsSubPortafoliosEnviar
      }

      data.subPortafolios = Object.assign({}, objPortafolios);

      productosService.crudProductos(data).then(
        response => {

          const {status, msg, data: datos} = response;

          if (status) {
            if(datos?.idmsg === 200){


              let portafolioString = "";
              try { portafolioString = validObjectKeys(data?.subPortafolios)?.arrRecursos[0].nmRecurso;} catch (e) { portafolioString = ""; }


              if(isAddMode){
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: datos?.txmsg } });


                if(tableRef){


                  tableRef.current.api.applyTransaction({
                    add: [{
                      id: datos?.idreg,
                      estado: data.estado,
                      nombre: data.nmProducto,
                      proveedor: isObject(data?.proveedor) ? data.proveedor.text : data.proveedor,
                      subMarca: isObject(data?.subMarca) ? data.subMarca.text : data.subMarca,
                      marca: isObject(data?.marca) ? data.marca.text : data.marca,
                      nbBarra: data?.codigoEan,
                      portafolio: portafolioString,
                      nbFamilia: isObject(data?.familia) ? data.familia.id : data.familia,
                      nmFamilia: isObject(data?.familia) ? data.familia.text : data.familia,
                      nbJerarquia: data?.jerarquia,
                      prcIVA: data?.iva,
                      tpProducto: isObject(data?.tipoProducto) ? data.tipoProducto.text : data.tipoProducto,
                      nbBarraAux: data?.codigoBarrasAuxiliar,
                      unidad: isObject(data?.unidadMedida) ? data.unidadMedida.text : data.unidadMedida,
                      peso_bruto: data?.peso,
                      peso_neto: data?.pesoNeto,
                      largo: data?.largo,
                      alto: data?.alto,
                      ancho: data?.ancho,
                      unidades_x_caja: data?.unidadesCaja,
                      unidades_x_display: data?.unidadesDisplay

                    }]
                  })
                }




              }
              else{

                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: datos?.txmsg } });

                if(params){
                  const rowNode = params.api.getRowNode(params.node.id);

                  rowNode.setDataValue("estado", data?.estado);
                  rowNode.setDataValue("nombre", data?.nmProducto);
                  rowNode.setDataValue("proveedor", isObject(data?.proveedor) ? data.proveedor.text : data.proveedor);
                  rowNode.setDataValue("nbBarra", data?.codigoEan);
                  rowNode.setDataValue("portafolio", portafolioString);

                  rowNode.setDataValue("nbBarraAux", data?.codigoBarrasAuxiliar);
                  rowNode.setDataValue("peso_bruto", data?.peso);
                  rowNode.setDataValue("peso_neto", data?.pesoNeto);
                  rowNode.setDataValue("largo", data?.largo);
                  rowNode.setDataValue("alto", data?.alto);
                  rowNode.setDataValue("ancho", data?.ancho);
                  rowNode.setDataValue("unidades_x_caja", data?.unidadesCaja);
                  rowNode.setDataValue("unidades_x_display", data?.unidadesDisplay);

                  if(isObject(data.unidadMedida)){
                    rowNode.setDataValue("unidad", data.unidadMedida.text);
                  }

                  if(isObject(data.familia)){
                    rowNode.setDataValue("nbFamilia", data.familia.id);
                    rowNode.setDataValue("nmFamilia", data.familia.text);
                  }

                  rowNode.setDataValue("nbJerarquia", data?.jerarquia);
                  rowNode.setDataValue("prcIVA", data?.iva);


                  if(isObject(data.tipoProducto)){
                    rowNode.setDataValue("tpProducto", data.tipoProducto.text);
                  }

                  if(isObject(data.subMarca)){
                    rowNode.setDataValue("subMarca", data.subMarca.text);
                  }
                  if(isObject(data.marca)){
                    rowNode.setDataValue("marca", data.marca.text);
                  }

                }
                else{
                  executeFn(objSubPortafoliosToViewPortafolios);
                }


              }


              modalCRUDService.clear();

            }
            else{
              dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: datos?.txmsg } });
            }

          } else {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
          }


        },
        error => {
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
        }
      );

    }

    const onErrorSubmit = errors => {
        console.log(errors)
    }

    useEffect(() => {
        register("jerarquia", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
        register("jsProducto", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
    }, [])


    return(
      <FormProvider {...methods} >
            <header className="px-4 d-flex align-items-center mw-100 mt-2 justify-content-between">

                <div className="row px-4">

                <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="tipoProducto" label="Tipo Producto"
                            required={true} options={generalServicesState?.arrTiposProductos}
                            className={`${classResponsiveFormDoubleWidth}`}
                            customError={errors.tipoProducto ? ERRORFIELDREQUIRED : null} showId={false} />

                <InputForm  inputProps={{control}} disabled={!isEditing} identificador="codProducto" type="text" label="Cod. Producto"
                            required={true} placeholder="Ej: 10001"  className={`${classResponsiveFormShort}`}
                            customError={errors.codProducto ? ERRORFIELDREQUIRED : null} />

                <InputForm  inputProps={{control}} disabled={!isEditing} identificador="nmProducto" type="text" label="Desc. Producto"
                            required={true} placeholder="Ej: Alpinito"  className={`${classResponsiveFormDoubleWidth}`}
                            customError={errors.nmProducto ? ERRORFIELDREQUIRED : null}/>

                <CalendarForm inputProps={{control}} disabled={true} identificador="dtCreacion"  label="Fecha Creación"
                                required={true} className={`px-2 w-auto`}
                                customError={errors.dtCreacion ? ERRORFIELDREQUIRED : null}/>

                <CalendarFormRange inputProps={{control}} disabled={!isEditing} identificador="dtVigencia" required={true}  label="Vigencia Ini - Fin"
                                     className={`w-auto`}
                                     customError={errors.dtVigencia ? ERRORFIELDREQUIRED : null}/>

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="estado" options={optionsEstados} required={true}
                                   defaultValue="1" label="Estado" className={`${classResponsiveForm}`}
                                   customError={errors.estado ? ERRORFIELDREQUIRED : null}/>


                </div>

                <div className="d-flex justify-content-end align-items-center">
                    { isEditing &&
                        <Tooltip title="Guardar" aria-label="guardar">
                            <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                               className="icon-container-actions d-flex">
                                <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                                <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-check fa-2x"/>
                            </a>
                        </Tooltip>
                    }
                    <Tooltip title="Cancelar" aria-label="cancelar">
                    <a onClick={() => {modalCRUDService.clear()}} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                        <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
                    </a>
                    </Tooltip>
                </div>

            </header>
            <RenderTabs isEditing={isEditing} properties={properties} stateSelects={generalServicesState} isAddMode={isAddMode}/>
      </FormProvider>
    )

}

export default FormProductosCRUD;
